import { render, staticRenderFns } from "./RecordLawsuit.vue?vue&type=template&id=13ea1d72"
import script from "./RecordLawsuit.vue?vue&type=script&lang=js"
export * from "./RecordLawsuit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports